import qs from "query-string"

export const getSubdomain = () => {
  
  if (typeof window === "undefined" || window.location.href.indexOf("buoyhealth.com") === -1) {
    return undefined
  }

  var subdomain = /:\/\/([^./]+)/.exec(window.location.href)
  if (subdomain) {
    subdomain = subdomain[1]
    // We don't really need to include this anymore, but we'll avoid a lot of
    // unnecessary calls to the backend resulting in 404s if we keep these sanity
    // checks for known subdomain lookalikes that aren't supported brands.
    if (
      !subdomain ||
      subdomain === "www" ||
      subdomain.startsWith("research") ||
      subdomain.startsWith("sandbox") ||
      subdomain.startsWith("staging")
    ) {
      return undefined
    }
  }
  return subdomain
}

export const getBrand = (prod = false) => {

  if (typeof window === "undefined") { return undefined }

  const query = qs.parse(window.location.search).brand
  const subdomain = getSubdomain()
  
  // In production, subdomain trumps the query string
  // In other environments, query string trumps subdomain for testing purposes
  let brand
  if (prod) {
    brand = subdomain ? subdomain : query
  } else {
    brand = query ? query : subdomain
  }

  return brand
}


// WEBPACK FOOTER //
// ./src/common/brands.js